// Components==============
import Button from 'components/UI/Button/Button';
import Checkbox from 'components/UI/Checkbox/Checkbox';
import TooltipMenu from 'components/UI/Tooltip/TooltipMenu';
import { useTranslate } from 'hooks/useTranslate';
import { MyPortfolioContext } from 'pages/Portfolio/MyPortfolios/MyPortfolio';
import React, { useContext } from 'react';
import './VisibilitySettings.module.scss';
// =========================

export default function VisibilitySettings() {
  const translate = useTranslate();
  const { handleChangeVisibility, currentPortfolio } = useContext(
    MyPortfolioContext
  );

  return (
    <>
      <TooltipMenu
        content={
          <div styleName="visibility-settings-popup">
            <div>
              <p>{translate('portfolio.visibility-settings.label')}</p>
              <p>{translate('portfolio.visibility-settings.description')}</p>
            </div>
            <Checkbox
              isChecked={!!(currentPortfolio?.visibility === 'public')}
              onClick={handleChangeVisibility}
            >
              {translate('portfolio.visibility-settings.reactions')}
            </Checkbox>
          </div>
        }
        position="bottom"
      >
        <Button color="grey">
          {translate('portfolio.actions.change-visibility')}
        </Button>
      </TooltipMenu>
    </>
  );
}
